exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-exclamation-triangle.text-warning[data-v-1d05437a] {\n    background:linear-gradient(#000,#000) center bottom/20% 84% no-repeat;\n}\n.warning-text[data-v-1d05437a] {\n    font-weight: bold;\n    position: relative;        \n    top: 5px;\n    line-height: 1.25em;\n}\n", ""]);

// exports
